import { getAmplitudeInstance } from '../amplitudeHelpers';
import ProductType from '../enums/ProductType';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logProPurchaseGetStartedClickedParams = {
  pro_landing_page_experiment_variant_name?: string;
  product_type?: ProductType;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User taps on green 'Get Started' CTA which triggers the checkout page
 * @param params - Attributes to log with the amplitude event
 * @param params.pro_landing_page_experiment_variant_name - The name of the variant that is being shown to the user - specific for Optimizely experiment ID: 21475990068.
 * @param params.product_type - The subscription type selected from the upsell menu (e.g. free, plus, peak)
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo).
 * @param params.trigger - The trigger that caused the web pro modal to display.
 */
const logProPurchaseGetStartedClicked = (
  { pro_landing_page_experiment_variant_name, product_type, purchase_screen_type_plan, trigger }: logProPurchaseGetStartedClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'pro purchase get started clicked',
    {
      'pro landing page experiment variant name': pro_landing_page_experiment_variant_name,
      'product type': product_type,
      'purchase screen type plan': purchase_screen_type_plan,
      trigger
    },
    callback
  );
};

export default logProPurchaseGetStartedClicked;
